export default __webpack_public_path__ + "static/media/lgn-tablet-side.86171b15.webp";